import React from "react";
import { Button } from "react-bootstrap";
import './HeaderHomePage.css';

export default function HeaderHomePage() {
  const handleLoginClick = () => {
    // Redirect to app subdomain for login
    window.location.href = 'https://app.prontoservices360.com/authentication/login';
  };

  const handleSignupClick = () => {
    // Redirect to app subdomain for signup
    window.location.href = 'https://app.prontoservices360.com/authentication/signup';
  };

  const handleLogoClick = () => {
    // Stay on the current page (root domain)
    window.location.href = 'https://prontoservices360.com';
  };

  return (
    <React.Fragment>
      <div className="pronto-header sticky-top">
        <div className="main-container container-fluid">
          <div onClick={handleLogoClick} className="header-logo" style={{ cursor: 'pointer' }}>
            <img
              src="/favicon.png"
              className="logo-1" 
              style={{ maxWidth: '45px' }}
              alt="Pronto Services 360 Logo"
            />
          </div>
          <div className="main-header-right">
            <div className="d-flex align-items-center">
              <Button 
                variant=""
                className="btn btn-outline-pronto me-3"
                type="button"
                onClick={handleSignupClick}
              >
                Business signup
              </Button>
              <Button 
                variant=""
                className="btn btn-outline-pronto"
                type="button"
                onClick={handleLoginClick}
              >
                Login
              </Button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
